import fetch from '../../api/fetch'

/**
 *  Action to get quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {string} URL [/quotes/step05/:quoteId]
 *  @method GET
 */
export function getQuoteVariation(quoteId: number, requestRate: boolean = false) {
    return {
        type: 'GET_STEP05_QUOTE_VAR',
        payload: fetch(`/quotes/step05/${quoteId}`, { method: 'GET' }),
        requestRate: requestRate,
    }
}

export function resetQuoteVariation() {
    return {
        type: 'RESET_STEP05_QUOTE_VAR',
    }
}

/**
 *  Action to get quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {string} URL [/quotes/step05/:quoteId]
 *  @method GET
 */
export function getRenewalVariation(quoteId: number) {
    return {
        type: 'GET_STEP05_RENEWALS_VAR',
        payload: fetch(`/renewal/step05/${quoteId}`, { method: 'GET' }),
    }
}

/**
 *  Action to remove quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId]
 *  @method GET
 */
export function delQuoteVariation(quoteId: number, quoteVariationId: number) {
    return {
        type: 'DEL_STEP05_QUOTE_VAR',
        payload: fetch(`/quotes/step05/${quoteId}/quoteVariations/${quoteVariationId}`, { method: 'DELETE' }),
        quoteId: quoteId,
    }
}

/**
 *  Action to create quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {string} URL [/quotes/step05/]
 *  @method POST
 */
export function createQuoteVariation(quoteId: number, requestRate: boolean = false) {

    let body = {
        'requestQuote': requestRate,
    }

    return {
        type: 'CREATE_STEP05_QUOTE_VAR',
        payload: fetch(`/quotes/step05/${quoteId}/AddQuoteVariation`, { method: 'POST', body: body }),
        quoteId: quoteId,
    }
}

export function getAllQuoteVariation(quoteId: number, requestRate: boolean = false) {
    return {
        type: 'GET_ALL_VARIATION',
        payload: {},
        quoteId: quoteId,
        requestRate: requestRate,
    }
}

export function createRateQuoteVariation(quoteId: number) {

    return {
        type: 'CREATE_STEP05c_QUOTE_VAR',
        payload: fetch(`/quotes/step05/${quoteId}/AddQuoteVariation`, { method: 'POST' }),
        quoteId: quoteId,
    }
}

/**
 *  Action to issue quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/quoteVariations/:quoteVariationId]
 *  @method POST
 */
export function issueQuoteVariation(quoteId: number, quoteVariationId: number) {

    return {
        type: 'ISSUE_STEP05_QUOTE_VAR',
        payload: fetch(`/quotes/step05/${quoteId}/quoteVariations/${quoteVariationId}`, { method: 'POST' }),
        quoteId: quoteId,
    }
}

export function inviteQuoteVariation(quoteId: number, renewalQuoteVariationId?: number) {
    let body = {
        'variationId': renewalQuoteVariationId ? renewalQuoteVariationId : null,
    }

    return {
        type: 'INVITE_STEP05_QUOTE_VAR',
        payload: fetch(`/policies/${quoteId}/renewal/invite`, { method: 'POST', body: body }),
    }
}

export function renewalBindQuoteVariation(quoteId: number, renewalQuoteVariationId?: number) {

    let body = {
        'variationId': renewalQuoteVariationId ? renewalQuoteVariationId : null,
    }

    return {
        type: 'RENEWAL_BIND_STEP05_QUOTE_VAR',
        payload: fetch(`/policies/${quoteId}/renewal/bind`, { method: 'POST', body: body }),
    }
}

/**
 *  Action to issue quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/quoteVariations/:quoteVariationId]
 *  @method POST
 */
export function updateQuoteVariation(quoteId: number, quoteVariationObject: any) {

    let body = {
        'quote': {
            'id': quoteId,
            'quoteVariations': [quoteVariationObject],
        },
    }

    return {
        type: 'UPDATE_STEP05_QUOTE_VAR',
        payload: fetch(`/quotes/step05`, { method: 'POST', body: body }),
        quoteId: quoteId,
    }
}

/**
 *  Action to issue quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/quoteVariations/:quoteVariationId]
 *  @method POST
 */
export function updateRenewalVariation(quoteId: number, quoteVariationObject: any) {

    let body = {
        'quote': {
            'id': quoteId,
            'quoteVariations': [quoteVariationObject],
        },
    }

    return {
        type: 'UPDATE_STEP05_RENEWAL_VAR',
        payload: fetch(`/renewal/step05`, { method: 'POST', body: body }),
        quoteId: quoteId,
    }
}
/**
 *  Action to bind quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/quoteVariations/:quoteVariationId/bind]
 *  @method POST
 */
export function bindQuoteVariation(
    quoteId: number,
    quoteVariationId: number,
    inceptionDate: string,
    bespokePolicyId: string) {

    return {
        type: 'BIND_STEP05_QUOTE_VAR',
        payload: fetch(`/quotes/step05/${quoteId}/quoteVariations/${quoteVariationId}/bind`, {
            method: 'POST',
            body: { inceptionDate, bespokePolicyId },
        }),
        quoteId: quoteId,
    }
}

/**
 *  Action to bind quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/quoteVariations/:quoteVariationId/get_soft_referrals]
 *  @method GET
 */
export function checkSoftReferral(quoteId: number, quoteVariationId: number) {

    return {
        type: 'CHECK_STEP05_SOFT_REF',
        payload: fetch(
            `/quotes/step05/${quoteId}/quoteVariations/${quoteVariationId}/get_soft_referrals`,
            { method: 'GET' }
        ),
        quoteId: quoteId,
    }
}

export function removeSoftReferral() {
    return {
        type: 'REMOVE_STEP05_SOFT_REF',
    }
}

/**
 *  Action to bind quote variations for step05
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/quoteVariations/:quoteVariationId/post_referral_reasons]
 *  @method GET
 */
export function postSoftReferral(quoteId: number, quoteVariationId: number, reasons: any) {

    return {
        type: 'POST_STEP05_SOFT_REF',
        payload: fetch(
            `/quotes/step05/${quoteId}/quoteVariations/${quoteVariationId}/post_referral_reasons`,
            { method: 'POST', body: reasons }
        ),
        quoteId: quoteId,
    }
}

/**
 *  Action to set Another market option
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/anotherMarket]
 *  @method POST
 */
export function setAnotherMarket(quoteId: number) {

    return {
        type: 'SET_ANOTHERMARKET',
        payload: fetch(
            `/quotes/step05/${quoteId}/anotherMarket`,
            { method: 'POST' }
        ),
    }
}

/**
 *  Action to set option to 'Discuss with Underwriter'
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/discussWithUnderwriter]
 *  @method POST
 */
export function setUnderwriter(quoteId: number) {

    return {
        type: 'SET_UNDERWRITER',
        payload: fetch(
            `/quotes/step05/${quoteId}/discussWithUnderwriter`,
            { method: 'POST' }
        ),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/step05.ts